import { useTheme } from "./useTheme";

const CYCLE = ["system", "light", "dark"] as const;
const LABEL: Record<(typeof CYCLE)[number], string> = {
  system: "Auto",
  light: "Light",
  dark: "Dark",
};
const ICON: Record<(typeof CYCLE)[number], string> = {
  system: "◐",
  light: "☀",
  dark: "☾",
};

export function ThemeToggle() {
  const [pref, setPref] = useTheme();

  const next = () => {
    const i = CYCLE.indexOf(pref);
    setPref(CYCLE[(i + 1) % CYCLE.length]);
  };

  // The sibling live region announces each change so screen-reader
  // users hear "Theme set to Dark" immediately after clicking,
  // without having to re-focus the button to re-read its aria-label.
  return (
    <>
      <button
        type="button"
        className="icon-button"
        aria-label={`Theme: ${LABEL[pref]} (click to change)`}
        title={`Theme: ${LABEL[pref]}`}
        onClick={next}
      >
        <span aria-hidden="true">{ICON[pref]}</span>
        <span style={{ marginLeft: "0.4rem" }}>{LABEL[pref]}</span>
      </button>
      <span role="status" aria-live="polite" className="visually-hidden">
        Theme set to {LABEL[pref]}
      </span>
    </>
  );
}
